import React, {useContext} from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import {AuthContext} from "../../config/AuthContext";
import Login from "../root/Login";
import NavBar from "../components/NavBar";
import SeccioMenuCards from "../components/SeccioMenuCards";

export default function Ecoambit() {
    const {isLoggedIn} = useContext(AuthContext);

    if (!isLoggedIn) return <Login/>;

    return (
        <>
            <NavBar/>
            <div className="general">
                <SeccioMenuCards
                    pantalla="menudesign"
                    titol="ECOAMBIT"
                    subtitol="Selecciona una secció per començar"
                />
            </div>
        </>
    );
}
